import { EVENTS, subscribe } from 'ia-util-pubsub';

class IaMainProduct extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    subscribe(EVENTS.variantChange, this.updateBlocks.bind(this));
    subscribe(EVENTS.planChange, this.updateSalePrice.bind(this));
    subscribe(EVENTS.cadenceChange, this.updateSalePrice.bind(this));
  }

  updateBlocks(e) {
    const { html, sectionId, productId } = e.detail;
    if (sectionId !== this.sectionId || productId !== this.productId) return;
    const blocks = this.querySelectorAll('[data-re-render]');
    blocks.forEach(block => {
      const newBlock = html.querySelector(`#${block.id}`);
      if (newBlock) {
        block.outerHTML = newBlock.outerHTML;
      }
    });
  }

  updateSalePrice(e) {
    const { productId, sectionId, cadence, plan, variant_price, plan_price, variant_compare_price } = e.detail;
    if (productId === this.productId && sectionId === this.sectionId) {
      this.querySelectorAll('.ia-price').forEach(priceContainer => {
        const salePriceEl = priceContainer.querySelector('[data-sale-price]');
        const comparePriceEl = priceContainer.querySelector('[data-sale-price-compare]');
        const variantComparePrice = priceContainer.dataset.variantComparePrice || variant_compare_price;
        const hasComparePrice = variantComparePrice && variantComparePrice !== variant_price && variantComparePrice !== '';

        if (cadence === 'subscription' && plan_price) {
          // Subscription: show strike variant compare price (or variant price if no compare), sale plan price
          if (salePriceEl) {
            salePriceEl.textContent = plan_price;
          }
          const comparePriceToShow = hasComparePrice ? variantComparePrice : variant_price;
          if (comparePriceEl) {
            comparePriceEl.textContent = comparePriceToShow;
            comparePriceEl.style.display = 'block';
          } else if (salePriceEl && comparePriceToShow) {
            // Create compare price element if it doesn't exist
            const strike = document.createElement('strike');
            strike.setAttribute('data-sale-price-compare', '');
            strike.textContent = comparePriceToShow;
            salePriceEl.parentNode.insertBefore(strike, salePriceEl);
          }

          // Update current plan price
          this.querySelectorAll('[data-current-plan-price]').forEach(currentPlanPriceEl => {
            currentPlanPriceEl.textContent = plan_price;
          });
        } else {
          // Onetime: show strike compare price (if exists and different), sale variant price
          if (salePriceEl) {
            salePriceEl.textContent = variant_price;
          }
          if (hasComparePrice) {
            if (comparePriceEl) {
              comparePriceEl.textContent = variantComparePrice;
              comparePriceEl.style.display = 'block';
            } else if (salePriceEl) {
              // Create compare price element if it doesn't exist
              const strike = document.createElement('strike');
              strike.setAttribute('data-sale-price-compare', '');
              strike.textContent = variantComparePrice;
              salePriceEl.parentNode.insertBefore(strike, salePriceEl);
            }
          } else {
            // No compare price, hide it
            if (comparePriceEl) {
              comparePriceEl.style.display = 'none';
            }
          }
        }
      });
    }
  }

  get productId() {
    return this.getAttribute('product-id');
  }
  get sectionId() {
    return this.getAttribute('section-id');
  }

}

if (!customElements.get('ia-main-product')) {
  customElements.define('ia-main-product', IaMainProduct);
}
